<template>
  <div class="main">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            工单信息
          </div>
        </template>
        <div class="collapse-content">
          <MessageForm :query="baseFormData"></MessageForm>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            维修项目
          </div>
        </template>
        <div class="collapse-content">
          <RepairProjectTable :data="componentTableData" ref="repairTable"></RepairProjectTable>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            工单验收
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="settleAccountsRef"
            class="vxe-table-element"
            size="mini"
            align="center"
            :auto-resize="true"
            :edit-rules="tableRules"
            :edit-config="{ trigger: 'click', mode: 'row' }"
            :data="tableData"
            :valid-config="{ autoPos: true, message: 'inline' }"
            @edit-closed="closeEditTableHandler"
            height="200"
          >
            <vxe-table-column
              v-for="(item, index) in columnListDefault"
              :key="index"
              :type="item.type"
              :fixed="item.fixed"
              :field="item.field"
              :title="item.title"
              :width="item.width"
              :sortable="item.sortable"
              :edit-render="item.editRender"
            >
              <template v-slot:edit="{ row }">
                <el-input
                  v-if="item.editRender.name == 'input'"
                  v-model="row[item.field]"
                ></el-input>
                <el-date-picker
                  v-else-if="item.editRender.name == 'datePicker'"
                  style="width: 100%"
                  v-model="row[item.field]"
                  type="date"
                  clearable
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </template>
            </vxe-table-column>
          </vxe-grid>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            完工附件
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="completeFileTableRef"
            :attachments="completeAttachments"
            :fileType="fileType"
            isShowDownBtn
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            验收附件
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :fileType="fileType"
            :limitFileCount="10"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="text-center">
      <div style="padding: 10px; background: #fff">
        <el-row class="page-row">
          <el-button type="primary" @click="confirmClick">通过</el-button>
          <el-button type="primary" @click="failClick">不通过</el-button>
          <el-button type="primary" @click="cancelClick" plain>取消</el-button>
        </el-row>
      </div>
    </footer>
  </div>
</template>

<script>
  import MessageForm from '../components/MessageForm';
  import RepairProjectTable from '../components/RepairProjectTable.vue';
  import { columnListDefault } from './index.js';
  import { checkTableRules } from './rule.js';
  import API from '@/api/property/workorder.js';
  import mixin from './../mixin';
  import btnMixins from './../btnMixins.js';
  export default {
    name: 'workorderCheck',
    mixins: [mixin, btnMixins],
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5'],
        attachments: [],
        completeAttachments: [],
        tableRules: checkTableRules,
        tableData: [],
        columnListDefault: columnListDefault,
        baseFormData: {
          workOrderCompanyNo: '',
          name: '',
          dispatchPersonName: '',
          workOrderDepartmentNo: '',
          relatedRepairFlag: '',
          repairNo: '',
          receivePersonName: '',
          contactPhone: '',
        },
        componentTableData: [],
        fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
      };
    },
    mounted() {
      let id = this.$route.query.id;
      this.getDetail(id);
    },
    methods: {
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 获取提交的数据
      async getSubmitData(checkflag) {
        let attachments = this.$refs.fileTableRef.getTableData();
        let checkFlag = checkflag;
        let workOrderDTO = {
          id: this.baseFormData.id,
          // repairNo:this.baseFormData.repairNo?this.baseFormData.repairNo:''
        };
        workOrderDTO.attachments = attachments;
        if (attachments.length) {
          workOrderDTO.workOrderNo = this.baseFormData.workOrderNo;
        }
        if (this.baseFormData.repairNo) {
          workOrderDTO.repairNo = this.baseFormData.repairNo;
        }
        let workOrderProjectDTOList = this.componentTableData;
        let workOrderCheckRecordDTOList = '';
        await this.getValidateTableData().then((res) => {
          workOrderCheckRecordDTOList = res.tableData.map((item) => {
            return {
              ...item,
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
              departmentCode: this.userInfo.departmentCode,
              departmentName: this.userInfo.departmentName,
              tenantCode: this.userInfo.tenantCode,
              tenantName: this.userInfo.Name,
            };
          });
        });
        this.loading.startLoading();
        let { data } = await this.$axios.post(API.WORKORDER_CHECK, {
          dispatchFlag: false,
          checkFlag,
          workOrderDTO,
          workOrderProjectDTOList,
          workOrderCheckRecordDTOList,
        });
        this.loading.endLoading();
        console.log('验收结果', data);
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.$store.dispatch('tagsView/delView', this.fromPath).then(() => {
            this.$nextTick(() => {
              this.$router.push(this.path);
            });
          });
        } else {
          this.$message.error(data.msg);
        }
      },
      handleChange(row, prop) {
        console.log('handleChange', row, prop);
      },
      // 通过
      confirmClick() {
        this.$refs.settleAccountsRef.validate((valid) => {
          if (valid) {
            this.$confirm('是否确认验收通过')
              .then(() => {
                this.getSubmitData(true);
                // this.$router.push(this.path);
              })
              .catch(() => {
                console.log('取消');
              });
          } else {
            this.$message.error('请检查数据再提交');
            return false;
          }
        });
      },
      // 不通过
      failClick() {
        this.$refs.settleAccountsRef.validate((valid) => {
          if (valid) {
            this.getSubmitData(false);
            // this.$router.push(this.path);
          } else {
            this.$message.error('请检查数据再提交');
            return false;
          }
        });
      },
      // 获取详情信息
      async getDetail(id) {
        let { data } = await this.$axios.post(`${API.WORKORDER_DETAIL}/${id}`);
        if (data.code == 0) {
          this.baseFormData = this.translateFiled(data.data, 'workOrderDTO');
          this.componentTableData = Object.freeze(
            this.translateFiled(data.data.workOrderProjectVOList, 'workOrderProjectVOList')
          );
          let workOrderCheckRecordVOList = data.data.workOrderCheckRecordVOList.filter((item) => {
            return !item.checkResult;
          });
          this.tableData = this.translateFiled(
            workOrderCheckRecordVOList,
            'workOrderCheckRecordVOList'
          );
          let attachments = data.data.attachments || [];
          this.completeAttachments = attachments.filter((item) => {
            return item.dataType == 'WORK_ORDER_COMPLETED';
          });
        }
      },
    },
    components: { MessageForm, RepairProjectTable },
  };
</script>

<style scoped></style>
